// extracted by mini-css-extract-plugin
export var borderRadius = "_6z-4";
export var large = "_6z-3";
export var logoContainer = "_6z-0";
export var nameLogo = "_6z-2";
export var small = "_6z-1";